const LocalStorageKeys = require('@/lib/Storage/LocalStorageKeys');

/**
 * @constructor
 *
 * @param $timeout
 * @param {LocalStorageDataStore} localStorageDataStore
 * @param {ReceiptPrinter} receiptPrinter
 */
const OrderReceiptPrinter = function (
    $timeout,
    localStorageDataStore,
    receiptPrinter,
) {
    this.$timeout = $timeout;
    this.localStorageDataStore = localStorageDataStore;
    this.receiptPrinter = receiptPrinter;

    /**
     * The "Print a VAT receipt" toggle on the payment modal controls this value.
     * It is held here so that the value is persisted between orders.
     * Note that it will default to false if ProPoint is refreshed.
     *
     * @type {boolean}
     */
    this.autoPrintTaxReceipts = !!this.localStorageDataStore.find(LocalStorageKeys.PRINT_TAX_RECEIPTS_SELECTED);
};

OrderReceiptPrinter.prototype = {
    setAutoPrintTaxReceipts(value) {
        this.autoPrintTaxReceipts = value;
        this.localStorageDataStore.persist(LocalStorageKeys.PRINT_TAX_RECEIPTS_SELECTED, value);
    },

    /**
     * @param {Order} order
     * @param {OrderAdjustmentResponse|null} [orderAdjustmentResponse]
     * @param {Order} [originalOrder]
     * @param {boolean} [printTaxReceipt]
     * @param {object} [additionalData]
     */
    printOrderReceipt(
        order,
        orderAdjustmentResponse,
        originalOrder,
        printTaxReceipt = false,
        additionalData = {}
    ) {
        // Order has a 'receiptPrinting' property even though ChangeCtrl also has a 'uiState.isPrinting' property,
        // because upon a new sale it's the SellCtrl not the ChangeCtrl that triggers the receipt printing.
        // Therefore, we use order.receiptPrinting to pass the "printing in progress" state to the ChangeCtrl.
        // Keep hold of the order that is being used to control the UI state in the ChangeCtrl,
        // because the value of the 'order' might change below.
        let orderForUi = order;
        orderForUi.receiptPrinting = true;

        if (orderAdjustmentResponse) {
            return this.receiptPrinter
                .printOrderAdjustmentReceipt(
                    orderAdjustmentResponse,
                    {
                        isDuplicate: !!orderForUi.receiptPrinted,
                        printTaxReceipt,
                    }
                )
                .then((result) => {
                    orderForUi.receiptPrinted = true;

                    return result;
                })
                .finally(() => {
                    this.$timeout(() => {
                        orderForUi.receiptPrinting = false;
                    });
                });
        }

        let isBalancePayment = false;
        if (!orderAdjustmentResponse && originalOrder) {
            // We can detect balance payments by it having an original order but not being an adjustment.
            isBalancePayment = true;
        }

        return this.receiptPrinter
            .printOrder(
                order,
                {
                    isDuplicate: !!orderForUi.receiptPrinted,
                    isBalancePayment,
                    printTaxReceipt,
                    ...additionalData,
                }
            )
            .then((result) => {
                orderForUi.receiptPrinted = true;

                return result;
            })
            .finally(() => {
                this.$timeout(() => {
                    orderForUi.receiptPrinting = false;
                });
            });
    },
};

module.exports = OrderReceiptPrinter;
